import { langPrefix } from '@/lib/locale-path';
// Readable address of an agency site: /en/agency/royal-realty.

const RESERVED = new Set([
  'admin', 'api', 'agency', 'agence', 'add', 'edit', 'login', 'logout', 'blog', 'compare',
  'calculators', 'calculatrices', 'partner', 'privacy', 'terms', 'maintenance', 'my-listings',
  'cabinet', 'realtor', 'restore-access', 'tax-calculator', 'uploads', 'sitemap', 'robots', 'new',
  'join-agency',
]);

export const AGENCY_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function normalizeAgencySlug(value: string | null | undefined): string {
  return String(value || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '')
    .slice(0, 60)
    .replace(/-$/, '');
}

// Returns an error message (in `lang`) when the address cannot be used.
export function agencySlugError(slug: string, lang: string): string | null {
  const isFr = lang === 'fr';
  if (slug.length < 3 || slug.length > 60) {
    return isFr ? "L'adresse doit contenir de 3 à 60 caractères." : 'The address must be 3 to 60 characters long.';
  }
  if (!AGENCY_SLUG_PATTERN.test(slug)) {
    return isFr
      ? 'Utilisez uniquement des lettres latines, des chiffres et des traits d’union.'
      : 'Use lowercase letters, numbers and hyphens only.';
  }
  if (RESERVED.has(slug)) {
    return isFr ? 'Cette adresse est réservée. Choisissez-en une autre.' : 'This address is reserved. Please choose another.';
  }
  return null;
}

// Path of an agency site; falls back to the id while an agency has no address yet.
export function agencyPath(lang: string, agency: { id: string; agency_slug?: string | null }): string {
  if (agency.agency_slug) {
    return `${langPrefix(lang)}/${lang === 'fr' ? 'agence' : 'agency'}/${agency.agency_slug}`;
  }
  return `${langPrefix(lang)}/realtor/${agency.id}`;
}
